import gql from 'graphql-tag'

import Price from '@Queries/cms/fragments/Price.fragment'

export default gql`
  ${Price}

  fragment PersonalizationOptions on ProductVariant {
    maxCharacters: attribute(key: "maxCharacters") {
      ... on BaseAttribute{
        value
      }
    }
    type: attribute(key: "type") {
      ... on BaseAttribute{
        value
      }
    }
    legacyID: attribute(key: "legacyOptionID") {
      ... on BaseAttribute{
        value
      }
    }
    shortName: attribute(key: "shortName") {
      ... on BaseAttribute{
        value
      }
    }
    price {
      ...PriceFragment
    }
  }
`
